import { trans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { ArrowUpIcon } from "lucide-react";
import {
  Button,
  DateInput,
  FileInput,
  NumberInput,
  SelectInput,
  SubmitButton,
  TextareaInput,
  TimeInput,
  errorToast,
} from "~/design-system/components";
import { Option } from "~/design-system/types";
import {
  requestCustomCakesStepsAtom,
  requestWeddingCakesDataAtom,
  requestWeddingCakesStepsAtom,
} from "../../atoms";
import { useRequestOrder } from "../../hooks";
import { requestWeddingCakesPortal } from "../RequestWeddingCakesPortal";

export function RequestWeddingCakeInformation() {
  const { handleSubmitOrderRequest, formData, orderOptions } = useRequestOrder({
    portal: requestWeddingCakesPortal,
    type: "wedding",
    dataAtom: requestWeddingCakesDataAtom,
    stepsAtom: requestCustomCakesStepsAtom,
  });

  const currentDate = new Date();

  return (
    <Form
      onSubmit={(e) => {
        if (e.values.tasteTestDate && e.values.deliveryDate) {
          const tasteTestDate = new Date(e.values.tasteTestDate);
          tasteTestDate.setHours(0, 0, 0, 0);
          const deliveryDate = new Date(e.values.deliveryDate);
          deliveryDate.setHours(0, 0, 0, 0);
          if (tasteTestDate >= deliveryDate) {
            e.form.submitting(false);
            errorToast(trans("tasteTestDateMustBeBeforeDeliveryDate"));
            return;
          }
        }
        handleSubmitOrderRequest(e);
      }}
      className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2 lg:gap-8"
    >
      <NumberInput
        name="numberOfServings"
        placeholder={trans("numberOfServings")}
        label={trans("numberOfServings")}
        defaultValue={formData?.numberOfServings}
        required
        autofocus
      />
      <SelectInput
        name="filling"
        multiple={true}
        placeholder={trans("flavor")}
        label={trans("flavor")}
        defaultValue={formData?.filling}
        required
        options={(orderOptions?.fillings as Option[]) || []}
      />
      <SelectInput
        name="size"
        placeholder={trans("numberOfTiers")}
        label={trans("numberOfTiers")}
        defaultValue={formData?.size}
        required
        options={(orderOptions?.sizes as Option[]) || []}
      />
      <FileInput
        name="images"
        label={trans("uploadThreePhotos")}
        required
        multiple
        maxFiles={3}
      />
      <DateInput
        minDate={currentDate}
        name="deliveryDate"
        label={trans("deliveryDate")}
        required
      />
      <TimeInput name="deliveryTime" label={trans("deliveryTime")} required />
      <DateInput name="tasteTestDate" label={trans("tasteTestDate")} required />
      <TextareaInput
        name="message"
        placeholder={trans("message")}
        label={trans("typeCakeMessage")}
        classes={{
          wrapper: "md:col-span-2",
        }}
        rows={6}
      />
      <div className="flex w-full flex-col items-center gap-4 md:col-span-2 md:flex-row">
        <Button
          onClick={() => requestWeddingCakesStepsAtom.update(1)}
          className="border-night col-span-2 w-full items-center justify-center rounded-full border bg-gray-200 px-8 py-3 text-center text-base font-semibold transition-colors duration-200 hover:bg-gray-300 sm:text-lg"
        >
          {trans("back")}
        </Button>
        <SubmitButton className="bg-primary-200 hover:bg-primary-300 border-night col-span-2 w-full items-center justify-center rounded-full border px-8 py-3 text-center text-base font-semibold transition-colors duration-200 sm:text-lg">
          {trans("sendRequest")} <ArrowUpIcon className="h-5 w-5 rotate-45" />
        </SubmitButton>
      </div>
    </Form>
  );
}
